<template>

<core-filter-config v-on:expand="onExpandClick" v-on:close="onCloseClick" v-on:save="onSaveClick" v-if="active" :state="is" :selfOnly="true">

	<app-config-template-other-currency />

</core-filter-config>

</template>

<script>

import Config from 'core/mixin/Config.js'

export default {

	mixins: [Config],

	data: function() {

		return {

			name: 'insights.worth'
			
		}

	},

	computed: {

		active: function() {

			return this.$route.name === 'InsightsWorth' 

		}

	},

	methods: {

		onAfterSave: function() {

			this.$emit('refresh')

		}

	}

}

</script>